import { render, staticRenderFns } from "./Browse-Folder.vue?vue&type=template&id=63485e62&scoped=true&"
import script from "./Browse-Folder.vue?vue&type=script&lang=js&"
export * from "./Browse-Folder.vue?vue&type=script&lang=js&"
import style0 from "./Browse-Folder.vue?vue&type=style&index=0&id=63485e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63485e62",
  null
  
)

export default component.exports